<template>
  <div>
    <spinner-round
      :is-loading="loading"
      v-if="loading"></spinner-round>
    <form
      v-else
      @submit.prevent.stop="submit()">
      <div class="is-padding">
        <div class="columns">
          <div class="column">
            <v-input
              id="name"
              :name="'name'"
              @input="val => origin.name = val"
              :model="origin.name"
              :errors-bag="errors"
              v-validate="'required|min:3'"
              data-vv-value-path="val"
              data-vv-as="Nom">
              <r-label
                slot="label"
                :is-required="true"
                :label="'Nom'"
                :value="origin.name"></r-label>
            </v-input>
          </div>
        </div>
        <div
          v-if="parent && mgcEnabled"
          class="columns">
          <div class="column is-4 columns is-column is-gapless is-space-between is-marginless">
            <r-label
              :label="'multidiffusion'"
              for="'multidiffusion'"
              :is-required="false"></r-label>
            <div class="control">
              <input
                id="multidiffusion"
                type="checkbox"
                name="multidiffusion"
                v-model="origin.multidiffusion"
                class="switch is-success is-rounded">
              <label for="multidiffusion">{{ origin.multidiffusion ? 'Oui' : 'Non' }}</label>
            </div>
          </div>
          <div
            v-if="origin.multidiffusion"
            class="column">
            <v-input
              id="multidiffusion_code"
              :name="'multidiffusion_code'"
              @input="val => origin.multidiffusion_code = val"
              :model="origin.multidiffusion_code"
              :errors-bag="errors"
              v-validate="'min:1'"
              data-vv-value-path="val"
              data-vv-as="CODE MGC CONNECTING">
              <r-label
                slot="label"
                :is-required="false"
                :label="'CODE MGC CONNECTING'"
                :value="origin.multidiffusion_code"></r-label>
            </v-input>
          </div>
          <div
            v-if="origin.multidiffusion"
            class="column">
            <v-input
              id="multidiffusion_name"
              :name="'multidiffusion_name'"
              @input="val => origin.multidiffusion_name = val"
              :model="origin.multidiffusion_name"
              :errors-bag="errors"
              v-validate="'min:2'"
              data-vv-value-path="val"
              data-vv-as="NOM MGC CONNECTING">
              <r-label
                slot="label"
                :is-required="false"
                :label="'NOM MGC CONNECTING'"
                :value="origin.multidiffusion_name"></r-label>
            </v-input>
          </div>
        </div>
      </div>
      <submit-sticky-buttons
        @submit="submit"
        :loading="submitLoading"
        button-id="originForm"></submit-sticky-buttons>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const emptyOrigin = {
  name: null,
  parent: null,
  multidiffusion: false,
  multidiffusion_name: null,
  multidiffusion_code: null
}

export default {
  name: 'OriginForm',
  props: {
    source: {
      type: Object,
      required: false
    },
    parent: {
      type: Object,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    submitLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      origin: {},
      origins: []
    }
  },
  computed: {
    ...mapGetters(['mgcEnabled'])
  },
  created () {
    if (this.source) {
      this.origin = Object.assign({}, this.source)
    } else {
      this.origin = Object.assign({}, emptyOrigin)
    }
  },
  methods: {
    async submit () {
      const formIsValid = await this.$validator.validateAll()
      if (formIsValid) {
        this.$emit('submit', this.origin)
      }
    }
  }
}
</script>
